import React from 'react';
import { FairPatchMutation } from '../graphql/mutations/FairPatchMutation';
import { FairEditQuery } from '../graphql/query/FairEditQuery';
import { EntityEditFetcher } from '../components/EntityEditFetcher';
import typeIntro from '../static/introspection/Fair.json';
import inputTypeIntro from '../static/introspection/FairPatchInput.json';
import { editorialSectionsToTree, getExpanded } from '../utils/tree';
import { toRefInput } from '../utils/dataTrasform';
import { ENTITY } from '../utils/entities';
import { graphqlQuery } from '../utils/graphql';
import { fastTransformer, refactorInfo, toTree } from '../utils/form';
import { TreeFieldType } from '../types/form';

export const FairEdit = ({ id }) => (
	<EntityEditFetcher
		fetcher={graphqlQuery(FairEditQuery, { id })}
		mutation={FairPatchMutation}
		entityName={ENTITY.FAIR}
		typeIntro={typeIntro}
		inputTypeIntro={inputTypeIntro}
		id={id}
		entitiesToFields={(props) => ({
			EditorialSections: props.editorialSectionTree,
		})}
		fields={[
			'name',
			'edition',
			'year',
			'logoMedia',
			'begin',
			'end',
			'targetSites',
			'goodClasses',
			'description',
			'descriptionIta',
			'website',
			'Country',
			'StateProvince',
			'postalCode',
			'city',
			'address1',
			'address2',
			'lat',
			'lng',
			'newsPath',
			'ourPavilion',
			'ourStand',
			'ourNote',
		]}
		transformer={(data, entity, listsByType) => {
			data.fields = fastTransformer({
				goodClasses: (f) => {
					if (f.type !== 'AsyncChoices') {
						refactorInfo(f, 'AsyncChoices');
						return f;
					}
					const newField: TreeFieldType = toTree(
						f,
						false,
						editorialSectionsToTree(listsByType.EditorialSections),
					);
					if (f.value) {
						newField.value = f.value.map((choice) =>
							toRefInput(choice.value),
						);
						newField.expanded = getExpanded(
							listsByType.EditorialSections,
							f.value,
						);
					}
					return newField;
				},
			})(data.fields);
			return data;
		}}
	/>
);
